import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'filters',
    path: 'is_past_due_date',
    viewPath: props.viewPath,
  })

  let value = useDataValue({
    context: 'filters',
    path: 'is_past_due_date',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(!value)
  }
}
